module.exports = __webpack_public_path__ + "media/retinus-pvp-demo-video2.22bc08ad.mp4";